var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vb-den-vt-index',{attrs:{"statusByVT":_vm.VB_INCOMING_DOC.STATUS_VANTHU.DA_TIEP_NHAN},on:{"viewDetail":_vm.viewDetail}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d49b4584","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-in/vbDenDaTiepNhanIndex.vue
// module id = AJTK
// module chunks = 89